import { whiteTheme } from '#web-components/styles';

export const drawColors = [
  { value: whiteTheme.colors.uIBlueBase, label: 'blue' },
  { value: whiteTheme.colors.uIGreenBase, label: 'green' },
  { value: whiteTheme.colors.uIYellowBase, label: 'yellow' },
  { value: whiteTheme.colors.uIRedBase, label: 'red' },
];
